export default "__VITE_ASSET__Df1$jbG8__"